// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guest-modal {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex; justify-content: center; align-items: center;
  z-index: 9999;
}

.guest-modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  font-family: "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.guest-modal-content h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 1.3rem;
  color: #0056b3; /* brand color */
}

.subheading {
  margin: 0 0 20px;
  font-size: 1rem;
  color: #555;
}

.guest-modal-content form input {
  width: 80%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.guest-modal-content form input:focus {
  outline: none;
  border-color: #0056b3;
  box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.2);
}

.guest-modal-content form input::placeholder {
  color: #999;
}

.guest-modal-content form button {
  width: 80%;
  padding: 10px;
  background: #0056b3;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  display: block;
  margin: 10px auto 0;
  transition: background-color 0.2s ease;
}

.guest-modal-content form button:hover:not(:disabled) {
  background: #004494;
}

.guest-modal-content form button:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.error-message {
  color: #d9534f;
  margin: 5px 0;
  font-size: 0.9rem;
}

.disclaimer {
  margin-top: 15px;
  font-size: 0.85rem;
  color: #777;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 480px) {
  .guest-modal-content {
    width: 95%;
    padding: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GuestInfoModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,8BAA8B;EAC9B,aAAa,EAAE,uBAAuB,EAAE,mBAAmB;EAC3D,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF","sourcesContent":[".guest-modal {\n  position: fixed;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex; justify-content: center; align-items: center;\n  z-index: 9999;\n}\n\n.guest-modal-content {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  font-family: \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.guest-modal-content h2 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  font-size: 1.3rem;\n  color: #0056b3; /* brand color */\n}\n\n.subheading {\n  margin: 0 0 20px;\n  font-size: 1rem;\n  color: #555;\n}\n\n.guest-modal-content form input {\n  width: 80%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.guest-modal-content form input:focus {\n  outline: none;\n  border-color: #0056b3;\n  box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.2);\n}\n\n.guest-modal-content form input::placeholder {\n  color: #999;\n}\n\n.guest-modal-content form button {\n  width: 80%;\n  padding: 10px;\n  background: #0056b3;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  display: block;\n  margin: 10px auto 0;\n  transition: background-color 0.2s ease;\n}\n\n.guest-modal-content form button:hover:not(:disabled) {\n  background: #004494;\n}\n\n.guest-modal-content form button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.error-message {\n  color: #d9534f;\n  margin: 5px 0;\n  font-size: 0.9rem;\n}\n\n.disclaimer {\n  margin-top: 15px;\n  font-size: 0.85rem;\n  color: #777;\n}\n\n/* Responsive adjustments for smaller screens */\n@media (max-width: 480px) {\n  .guest-modal-content {\n    width: 95%;\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
